﻿window.EnableLeaveIntent = () => {
	if (typeof window.enableLeaveIntent !== "undefined") {
		window.enableLeaveIntent = true;
	}
};

window.DisableLeaveIntent = () => {
	if (typeof window.enableLeaveIntent !== "undefined") {
		window.enableLeaveIntent = false;
	}
};

namespace eXpress.web.leaveIntentLoader {

	const isLeaveIntentEnabled = (): boolean => {
		return typeof window.enableLeaveIntent !== "undefined" && window.enableLeaveIntent && window.location.search.indexOf("embed") < 0;
	};

	const initLeaveIntentPopup = (enableAnyway: boolean) => {
		// Do nothing for the upload page
		if (!isLeaveIntentEnabled() && !enableAnyway)
			return;

		try {
			ouibounce(false, {
				sensitivity: 20,
				aggressive: false,
				sitewide: true,
				timer: 1000,
				delay: 100,
				callback: triggerLeaveIntentPopup,
				cookieExpire: 1,
				canFire: isLeaveIntentEnabled
			});
		} catch (exc) {
			// Adblocker probably blocked ouiBounce from loading.
		}
	};

	const subscribeAsync = (email: string, source: string, dialogEl: HTMLElement) => {
		return $.ajax({
			url: '/api/v1/AccountService.svc/json/Subscribe',
			type: 'POST',
			global: false,
			contentType: 'application/json; charset=utf-8',
			data: JSON.stringify(
				{
					applicationId: window.dataLayerSite[0].appId,
					pointOfSaleId: window.dataLayerSite[0].posId,
					language: window.dataLayerSite[0].language,
					email,
					source,
					newsletter: true
				}
			),
			dataType: 'json',
		}).then(() => {
			//
		}) as JQueryPromise<void>;
	};

	const triggerLeaveIntentPopup = () => {
		let dialog: core.StyleguideViewPopup;
		core.StyleguideViewPopup.createCoreDialogAsync(
			{
				dialogId: "leave-intent-dialog",
				view: "leaveintentdialog"
			}
		)
			.then($popup => {
				const dialogEL = $popup[0];
				if (!dialogEL) return;

				// hide maindialog cover for non ux pages
				const mainDialogCoverEl = html.querySelector<HTMLElement>(document, "#maindialogcover");
				mainDialogCoverEl && mainDialogCoverEl.classList.add('u-hide');

				const subscribeComponent = html.querySelector<HTMLElement>(dialogEL, '.technical-newsletter-subscribe', true);
				eXpress.components.main.createNewsletterSubscribe(subscribeComponent, { subscribeAsync: (email: string, appId: string, posId: string, lang: string, source?: string) => subscribeAsync(email, source || '', dialogEL) });

				dialog = new core.StyleguideViewPopup($popup);
				dialog.openAsync();
			});
	};

	/* tslint:disable:interface-name */
	interface CookieBot {
		readonly consent: { marketing: boolean };
		readonly dialog: {
			readonly DOMid: string;
		};
	}

	//window.addEventListener("CookiebotOnDialogDisplay", () => {
	//	const cookieBot = window.Cookiebot as CookieBot;
	//	const cookiebotDialogEl = html.querySelector(document, `#${cookieBot.dialog.DOMid}`, true);
	//	cookiebotDialogEl.addEventListener('click', e => {
	//		e.stopPropagation();
	//	});
	//});

	window.addEventListener("CookiebotOnAccept", () => {
		const cookieBot = window.Cookiebot as CookieBot;
		if (cookieBot.consent.marketing && (typeof window.enableLeaveIntentConfigValue === "undefined" || window.enableLeaveIntentConfigValue)) {
			EnableLeaveIntent();
			initLeaveIntentPopup(true);
		}
	});

	initLeaveIntentPopup(false);
}
